<cc-state-toggle
  [theme]="stateToggleTheme"
  defaultValue="sitemateLinks"
  *ngIf="appHierarchy.Team === hierarchy"
>
  <cc-state-toggle-item value="sitemateLinks" data-test="sitemate-links-button" routerLink="./links"
    >Sitemate Links
  </cc-state-toggle-item>
  <cc-state-toggle-item value="formUsers" data-test="paid-users-link-button" routerLink="./"
    >Paid Users
  </cc-state-toggle-item>
</cc-state-toggle>

<router-outlet *ngIf="url === 'links'; else formTable"></router-outlet>

<ng-template #formTable>
  <div class="sm-flex sm-h-full sm-min-h-0 sm-flex-col">
    <cc-panel-with-links-header
      title="Sitemate Paid Users"
      [learnMoreLink]="'https://intercom.help/dashpivot/en/articles/5490238-form-users'"
      [linksCount]="assignedUsers.length"
    >
      <div *ngIf="isBannerVisible" class="sm-pb-4">
        <cc-banner
          data-test="visitor-user-plan-type-banner"
          type="warning"
          icon="warning"
          alignment="center"
          width="fit-content"
          [bannerText]="bannerText"
        >
          <button class="sm-text-default-blue sm-underline" (click)="openUpgradeModal()">
            {{ upgradePlanMessage }}
          </button>
        </cc-banner>
      </div>
    </cc-panel-with-links-header>

    <div class="subtitrle sm-mb-4">
      <span i18n *ngIf="appHierarchy.Team !== hierarchy"
        >These users have access to templates specified in one or more Ongoing Sitemate Links via the Sitemate
        app.</span
      >
      <span i18n *ngIf="appHierarchy.Team === hierarchy"
        >These users have access to templates specified in one or more Ongoing Sitemate Links via the Sitemate
        app.</span
      >
    </div>
    <div class="loading-spinner" *ngIf="isLoading; else loadedContent">
      <i class="cc-icon cc-icon-spinner" aria-hidden="true"></i>
    </div>

    <ng-template #loadedContent>
      <div class="sm-flex sm-min-h-0 sm-flex-1 sm-flex-col">
        <div class="actions-container">
          <cc-user-list-search-bar
            [(searchTerm)]="searchTerm"
            (searchTermChange)="onSearch()"
            *ngIf="!checkedUsers.size"
          ></cc-user-list-search-bar>

          <div class="sm-flex sm-items-center sm-space-x-2" *ngIf="checkedUsers.size">
            <button
              class="button-regular cc-btn-subtle-gray text-danger remove-user-button"
              *ngIf="!checkedUsers.has(currentUserId)"
              (click)="onDeleteUsers()"
            >
              <i class="cc-icon cc-icon-delete sm-text-default-red" aria-hidden="true"></i>
              <span class="sm-text-sm sm-text-black">Remove</span>
            </button>
          </div>
        </div>

        <div class="user-list-table">
          <div class="table-header">
            <div
              class="actions-cell"
              (click)="onCheckAll()"
              *ngIf="isTeamControllerOrAbove && filteredList?.length"
            >
              <input
                type="checkbox"
                class="checkbox-input header-checkbox"
                data-test="select-all-checkbox"
                [ngModel]="sortedList.length && sortedList.length === checkedUsers.size"
              />
            </div>
            <div
              class="table-cell sm-whitespace-nowrap"
              *ngFor="let column of tableHeaders"
              scope="col"
              i18n
              (click)="onSort(column.name)"
              [attr.data-test]="'table-header-' + column.name"
            >
              {{ column.label }}
              <cc-user-list-sorting-icon
                data-test="sort-icon"
                [isActive]="sortingColumn === column.name"
                [currentSortOrder]="currentSortOrder"
              ></cc-user-list-sorting-icon>
            </div>
          </div>

          <ng-template #bodyResults>
            <div class="table-body">
              <div class="table-row" *ngIf="!assignedUsers?.length">
                <span class="text-muted no-users sm-inline-block sm-w-full sm-text-center">
                  No Sitemate Users have accessed any Sitemate Links yet
                </span>
              </div>
              <div
                class="table-row"
                *ngFor="let user of filteredList; let index = index"
                [class.selected-row]="checkedUsers.has(user.id)"
                [attr.data-test]="'table-row-' + index"
              >
                <div class="actions-cell" (click)="onCheck(user)" *ngIf="isTeamControllerOrAbove">
                  <input
                    type="checkbox"
                    class="checkbox-input"
                    [attr.data-test]="'checkbox-' + index"
                    [ngModel]="checkedUsers.has(user.id)"
                  />
                </div>
                <div class="table-cell">
                  <span class="sm-flex sm-flex-row sm-items-center sm-space-x-2">
                    <cc-user-avatar [user]="user"></cc-user-avatar>
                    <span
                      [title]="user?.firstName"
                      [innerHTML]="user?.firstName | textEmphasis : searchTerm : 'bold'"
                      data-test="user-first-name"
                    >
                    </span>
                  </span>
                </div>
                <div
                  class="table-cell"
                  data-test="user-last-name"
                  [title]="user?.lastName"
                  [innerHTML]="user?.lastName | textEmphasis : searchTerm : 'bold'"
                ></div>
                <div
                  class="table-cell"
                  data-test="user-company-name"
                  [title]="user?.companyName"
                  [innerHTML]="user?.companyName | textEmphasis : searchTerm : 'bold'"
                ></div>
                <div class="table-cell links-cell">
                  <button
                    class="link-button"
                    data-test="templates-links-accessed"
                    (click)="onTemplateLinkAccessed(user)"
                  >
                    {{ user.taskLinks }} Link{{ user.taskLinks > 1 ? 's' : '' }}
                  </button>
                </div>
              </div>
            </div>
          </ng-template>

          <div
            *ngIf="assignedUsers?.length && !filteredList?.length; else bodyResults"
            class="no-results-container"
          >
            <div class="picture-container">
              <img
                src="/assets/images/user/no-results.svg"
                alt="No results"
                data-test="user-list-empty-message"
                class="sm-h-full sm-w-auto"
              />
              <p i18n>Oops! No results</p>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #templateLinksModal let-close="close">
      <cc-template-links-list-modal
        [assignedUser]="assignedUser"
        [hierarchy]="hierarchy"
        (close)="close()"
      ></cc-template-links-list-modal>
    </ng-template>
  </div>
</ng-template>
